import React, { useEffect } from "react";
import logo from "../../../assets/img/new_ss_logo.png";
import { altAttribute } from "../../../utils/utils";
import "./class.public.css";

/** Google Fonts used by the v2 design system (Figtree, Inter, Urbanist). */
const V2_FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700&family=Inter:wght@400;500;600;700&family=Urbanist:wght@500;600;700&display=swap";

/** Adds the v2 font stylesheet to `<head>` once; later calls do nothing. */
function ensureV2FontsLoaded() {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById("edsimsV2-fonts")) {
    return;
  }
  const link = document.createElement("link");
  link.id = "edsimsV2-fonts";
  link.rel = "stylesheet";
  link.href = V2_FONTS_HREF;
  document.head.appendChild(link);
}

/** Props for {@link ClassPublicShell}. */
interface ClassPublicShellProps {
  /** Page heading; omitted while it is still loading. */
  title?: string;
  /** Heading alignment (default `start`). */
  titleAlign?: "start" | "center";
  children: React.ReactNode;
}

/**
 * Page chrome for the anonymous class pages (landing and Access Simulation): skip link,
 * SchoolSims logo bar, optional heading, and the main content area.
 */
const ClassPublicShell: React.FC<ClassPublicShellProps> = ({
  title,
  titleAlign = "start",
  children,
}) => {
  useEffect(() => {
    ensureV2FontsLoaded();
  }, []);

  return (
    <div id="edsimsV2-root" className="ss-class-public">
      <a className="edsimsV2-skip-link" href="#content">
        Skip to content
      </a>
      <header className="ss-v2-topbar">
        <a
          href="https://www.schoolsims.com"
          className="ss-v2-logo-link"
          rel="home"
        >
          <img
            src={logo}
            alt={altAttribute.logoAlt}
            className="ss-v2-logo"
          />
        </a>
      </header>
      <main id="content" tabIndex={-1} className="ss-v2-main">
        {title ? (
          <h1
            className={
              titleAlign === "center"
                ? "ss-v2-page-title ss-v2-page-title--center"
                : "ss-v2-page-title"
            }
          >
            {title}
          </h1>
        ) : null}
        {children}
      </main>
    </div>
  );
};

export default ClassPublicShell;
